/* eslint-disable @next/next/no-img-element */
import { PlayIcon } from '@heroicons/react/solid'
import React, { useRef, useState } from 'react'
import { cfLoader } from './Image'

export const Video: React.FC<{ src: string; alt: string; caption?: React.ReactNode }> = ({
  src,
  caption,
  alt,
}) => {
  const video = useRef(null)
  const [isPlaying, setIsPlaying] = useState(false)

  const handleClick = () => {
    if (video.current) {
      if (video.current.paused) {
        video.current.play()
      } else {
        video.current.pause()
      }
    }
  }

  const handleVideoRef = (el) => {
    if (el) {
      video.current = el
      el.addEventListener('play', () => setIsPlaying(true))
      el.addEventListener('pause', () => setIsPlaying(false))
    }
  }

  return (
    <figure className="not-prose relative aspect-video text-center">
      <div
        aria-hidden="true"
        onClick={handleClick}
        style={{ opacity: isPlaying ? 0 : null }}
        className="absolute inset-0 z-20 flex cursor-pointer items-center justify-center opacity-0 transition-opacity hover:opacity-100"
      >
        <PlayIcon className="h-80 w-80 text-gray-800 opacity-50" />
      </div>
      <div className="absolute inset-0 z-0">
        <img
          ref={(el) => {
            if (el) {
              // when page is rendered with next router, the image for some bizarre reason has width = 0
              // so let's override it here
              el.setAttribute('width', '100%')
              const resizeObserver = new ResizeObserver((entries) => {
                for (const entry of entries) {
                  let width
                  if (entry.contentBoxSize && entry.contentBoxSize.length > 0) {
                    width = entry.contentBoxSize[0].inlineSize
                  } else {
                    width = entry.contentRect.width
                  }
                  const widths = [672, 762]
                  const targetWidth = widths.find((w) => w > width) || widths.at(-1)
                  el.src = cfLoader({ src: `${src}.png`, width: 762 })
                  el.srcset = `${cfLoader({
                    src: `${src}.png`,
                    width: targetWidth,
                  })} 1x, ${cfLoader({
                    src: `${src}.png`,
                    width: targetWidth * 2,
                  })} 2x`
                }
              })

              resizeObserver.observe(el)
            }
          }}
          width="100%"
          alt={alt}
          className="aspect-video"
        />
      </div>
      <video
        className="relative z-10 aspect-video w-full"
        muted
        playsInline
        preload="none"
        ref={handleVideoRef}
      >
        <source src={`${src}.webp`} type="video/webp" />
        <source src={`${src}.mp4`} type="video/mp4" />
      </video>
      {caption && <figcaption className="pt-2 text-sm text-gray-500">{caption}</figcaption>}
    </figure>
  )
}
